export default __webpack_public_path__ + "static/media/localizacao.4d407eb2.png";